import get from 'lodash/get';

// This function replaces placeholders enclosed in curley braces with the actual value. For example:
// "http://www.clientwebsitesite.com/fundexplorer/{isin}" -> "http://www.clientwebsitesite.com/fundexplorer/GB1234567890"

export const replacePlaceholders = (values: {}, text: string, valueKey?: string) => {
    const parsedText = text.replace(/({)[^{]+(})/g, (match) => {
        const value = match.replace('{', '').replace('}', '');
        return get(values, `${value}${valueKey ? valueKey : ''}`, '');
    });

    return parsedText;
};

export const replacePropertyPlaceholders = (values: {}, text: string) => {
    return replacePlaceholders(values, text, '.value');
};


// WEBPACK FOOTER //
// ./src/utils/replacePlaceholders.ts